import { defineMessages } from 'react-intl';

export default defineMessages({
  InvoiceDateFrom: 'Invoice date from',
  InvoiceDateUntil: 'Invoice date until',
  WithEmployeeTags: 'With employee tags',
  RelationRentability: 'Relation rentability',
  PerformanceBalance: 'Performance balance',
  InvoiceDateFrom: 'Invoice date from',
  InvoiceDateUntil: 'Invoice date until',
  NoInvoicingSchedule: 'No schedule',
  WithInvoicingSchedule: 'With invoicing schedule',
  InvoicingViaRelations: 'Invoicing via relations',
  Totals: 'Totals',
  Total: 'Total',
  ExportToExcel: 'Export to excel',
  ShowHoursInsteadOfAmounts: 'Show hours',
  None: 'None',
  NoDataForReport: 'Could not find any data using the current filters',
  Assignment: 'Assignment',
  ExportToExcelStarted: 'Export to excel started',
  IncludeInactiveRelations: 'Show inactive',

  Relation: 'Relation',
  InvoicingType: 'Invoicing type',
  InvoiceSchedule: 'Invoice schedule',
  RegisteredHours: 'Registered hours',
  RemovedHours: 'Removed hours',
  AddedHours: 'Added hours',
  ManipulatedHours: 'Manipulated hours',
  BilledHours: 'Billed hours',
  AddedHoursAmount: 'Added Hours Amount',
  RemovedHoursAmount: 'Removed Hours Amount',
  TotalHoursAmount: 'Total Hours Amount',
  RegisteredCosts: 'Registered costs',
  RemovedCosts: 'Removed costs',
  AddedCosts: 'Added costs',
  BilledCosts: 'Billed costs',
  ManipulatedCosts: 'Manipulated costs',
  FreeLines: 'Free lines',
  Turnover: 'Turnover',
  InternalCost: 'Internal cost',
  Profit: 'Profit',
  TurnoverMinInternalCost: 'Turnover - internal cost',
  TurnoverMinRegistered: 'Turnover - registered hours & costs',
  Rentability: 'Rentability',
  OpenRegisteredHours: 'Open registered hours',
  OpenRegisteredCosts: 'Open registered costs',
  NeverInvoiceRegisteredHours: 'Never invoice hours',
  NeverInvoiceRegisteredCosts: 'Never invoice costs',
  AllCompanies: 'All companies',
  AllTaskTemplates: 'All task templates',
  AllUsers: 'All users',
  WithoutTemplate: 'Without template',
  WithLabels: 'With labels',
  WithoutLabels: 'Without labels',
  TaskTemplate: 'Task template',
  FillPeriodWithWork: 'Fill period with work',
  FillPeriodWithRecup: 'Fill period with recup',
  FillPeriodWithAbsence: 'Fill period with absence',
  /* Excel columns */
  InvoicingScheduleName: 'Invoice schedule',
  RegisteredHoursAmount: 'Registered hours amount',
  BillableHoursAmount: 'Billable hours amount',
  BilledHoursAmount: 'Billed hours amount',
  AverageUnitPrice: 'Average unit price',
  OpenRegisteredHoursAmount: 'Open registered hours amount',
  OpenBillableHours: 'Open billable hours',
  OpenBillableHoursAmount: 'Open billable hours amount',
  InvoicedAmount: 'Invoiced amount',
  Balance: 'Balance',

  /* PerformanceBalance (Onderhanden werk) */
  BillableHours: 'Billable hours',
  BillableHoursValue: 'Billable hours value',
  CorrectionHours: 'Correction hours',
  CorrectionHoursValue: 'Correction hours value',
  BillableCostsValue: 'Billable costs value',
  Invoiced: 'Invoiced',

  /* HoursPerEmployee */
  HoursPerEmployee: 'Hours per eployee',
  GroupBy: 'Group by',
  GroupByDay: 'Day',
  GroupByWeek: 'Week',
  GroupByMonth: 'Month',
  GroupByYear: 'Year',
  Employee: 'Employee',
  DateFrom: 'From',
  DateUntil: 'Until',
  DateFromRequired: 'The from date is required',
  ExpectedHours: 'Expected hours',
  WorkedHours: 'Worked hours',
  AbsenceHours: 'Absence hours',
  TrainingHours: 'Training hours',
  RecuperationHours: 'Recuperation hours',
  FilledInHours: 'Filled in hours',
  CappedFilledInHours: 'Capped filled in hours',
  OvertimeHours: 'Overtime hours',
  OvertimeCorrectionHours: 'Overtime correction hours',
  RemainingOvertimeHoursPeriod: 'Remaining overtime (period)',
  RemainingOvertimeHoursAll: 'Remaining overtime (all)',

  MissingHours: 'Missing hours',
  HomeWorkingHours: 'Home working hours',
  RegisterWorkingFromHome: 'Register working from home',
  ClearWorkingFromHome: 'Clear working from home',
  WorkingFromHome: 'Working from home',

  /* InvoicingHistory */
  InvoicingHistory: 'Invoicing history',
  DraftInvoiceAmount: 'Draft invoice amount',
  ToInvoice: 'ToInvoice',
  ToInvoiceHours: 'ToInvoiceHours',
  NextScheduleDate: 'Next schedule date',
  NextScheduleAmount: 'Next schedule amount',
  AvgAmountPerHour: 'Avg amount per hour',
  WrittenOffAmount: 'Written off amount',

  BilledAmount: 'Billed amount',
  RegisteredHoursBilled: 'Registered hours (billed)',
  AvgAmountPerHourBilled: 'Avg amount per hour (billed)',
  BilledPerMonth: 'Billed per month',
  FixedAmountOrAdvance: 'Fixed amount/advance',
  LastInvoiceDate: 'Last invoice date',

  Potential: 'Potential',
  SelectColumns: 'Select columns',
  ColumnConfig: 'Configure columns',

  RegistrationsPerTaskTemplate: 'Registrations per task template',
  RegistrationsPerResourceCategory: 'Registrations per resource category',
  /* RegistrationsPerRelation */
  RegistrationsPerRelation: 'Registrations per relation',
  RegistrationsPerUser: 'Registrations per user',
  NotBillable: 'Not billable',
  Invoiced: 'Invoiced',
  InvoicedInForfait: 'Invoiced in forfait',
  Deleted: 'Deleted',
  NeverInvoice: 'NeverInvoice',
  InvoicedMinusPotential: 'Invoiced - Potential',
  Hours: 'Hours',
  Quantity: 'Quantity',
  Amount: 'Amount',
  Name: 'Name',
  Remark: 'Remark',
  InForfait: 'In forfait',
  InvoiceStatus: 'Invoice status',
  FilterRegistrationUser: 'Select registration user',
  RegistrationDateFrom: 'Reg. from',
  RegistrationDateUntil: 'Reg. until',
  Details: 'Details',
  ShowDetails: 'Show details?',
  Margin: 'Margin',
  InvoicedMinusInternalCost: 'Invoiced - Int. cost',
  NotRegisteredOnTask: 'Not registered on task',
  NotRegisteredOnSubTask: 'Not registered on subtask',
  ExportDetailsToExcel: 'Export details',
  ResetFilters: 'Reset filters',
  WithoutReferenceYear: 'Without reference year',
  WrittenOffInternally: 'Written off internally',

  /* AbsencePerEmployee */
  AbsencePerEmployee: 'Absence per employee',
  AllOvertimeHours: 'All overtime hours',
  AllRecuperationHours: 'All recuperation hours',
  RemainingOvertimeHours: 'Remaining overtime hours',
  ShowAbsencesInDays: 'Show absences in days',

  OpenRegistrationOverview: 'Open registration overview',
  AddRegistration: 'Add registration',
  AddAbsence: 'Add absence',
  AddRecuperation: 'Add recuperation',
  AddTraining: 'Add training',
  OvertimeHoursTooltip: 'Overtime hours: {value}',
  MissingHoursTooltip: 'Missing hours: {value}',
  HomeWorkingHoursTooltip: 'Home working hours: {value}',
  ZoomInToDayView: 'Zoom in to day view',
  SystemUser: 'System user',
  EmployeeType: 'Employee type',
  WithPriceListItem: 'With price list item',

  AbsenceCalendar: 'Absence calendar',
  OnlyEmployeesWithAbsences: 'Show only employees with absences',
  Holiday: 'Holiday',
  AbsenceTypes: 'Absence types',
  AddRegistrationFor: 'Add registration for {user}',
  AddAbsenceFor: 'Add absence for {user}',
  AddRecuperationFor: 'Add recuperation for {user}',
  AddTrainingFor: 'Add training for {user}',
  OnlyEmployeesWithMissingHours: 'Only show employees with missing hours',
  OwnCompanyEmployees: 'Own company (employees)',
  Sector: 'Sector',
  GlobalActions: 'Global actions',
});
